import { type Common } from './common.js';
import { type ExternalOrder } from './models/externalOrder.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/external-orders/';
  }

  async findAllByExternalDocumentPacketId(documentPacketId: string): Promise<{
    orders: ExternalOrder[];
  }> {
    const url = this.common.constructPath(`${this.baseEndpoint}doc-packet/${documentPacketId}`);
    return await this.common.getJSON(url);
  }
}
